<template>
  <div class="book-outlink">
    <template v-if="bookDetail">
      <iframe
        id="iframe"
        width="100%"
        height="100%"
        :src="bookDetail.readbooks_url"
        frameborder="0"
      ></iframe>
    </template>

    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="popTipsCont.dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import PopTips from "@/components/popTips";
import BookHttp from "./book";
export default {
  name: "Book_bookOutlink",
  data() {
    return {
      bookDetail: null,
      timer: null,
      inTime: 0,
      popTipsCont: {
        dialogVisable: false,
        title: this.$t('blendType.reword'),
        context: `<span class="gold"></span> +4`,
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      }
    };
  },
  components: {
    PopTips
  },
  created() {
    this.$store.dispatch("setLoadingStatus", true);
    this.id = this.$route.query.readbooks_id;
    this.outTime = this.$route.query.readbooks_addgoldtime
    this.outGold = this.$route.query.readbooks_goldcorrect
    this.getOneBook(this.id);
  },
  mounted () {
    this.iframeLoadOver()
  },
  watch: {
    bookDetail() {
      this.$nextTick(() => {
        let iframe = document.getElementById("iframe");
        iframe.addEventListener(
          "load",
          () => {
            this.$store.dispatch("setLoadingStatus", false);
          },
          false
        );
      });
    }
  },
  methods: {
    iframeLoadOver () {
      this.timer = setInterval(() => {
        if (this.inTime < this.outTime) {
          this.inTime++
        } else {
          clearInterval(this.timer)
          this.inTime = 0
          this.AddBooksGold()
        }
      }, 1000)
    },
    handleCloseTip() {
      this.popTipsCont.dialogVisable = false;
    },
    handConfirm() {
      this.popTipsCont.dialogVisable = false;
    },
    // 看书 加 金币
    AddBooksGold() {
      BookHttp.AddBooksGold({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.$store.state.currentChild.student_id,
        readbooks_id: this.$route.query.readbooks_id,
        readbooks_title: this.$route.query.readbooks_title,
        gold: this.outGold
      }).then(res => {
        const { error, result } = res.data;
        if (error == 0) {
          this.popTipsCont.dialogVisable = true
          this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`
          let childInfo = this.$store.state.currentChild;
          
          childInfo.student_goldprice = Number(childInfo.student_goldprice) + Number(result.list.playprice);
          this.$Tool.setStorage("currentStuInfo", childInfo);
          this.$store.dispatch("setCurrentChild", childInfo);
        }
      });
    },
    // 获取 单个图书详情
    getOneBook(readbooks_id) {
      console.log(this.$store.state.currentChild.student_id,)
      BookHttp.getOneBook({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.$store.state.currentChild.student_id,
        readbooks_id
      }).then(res => {
        const { result } = res.data;
        this.bookDetail = Object.assign({}, result.list);
      });
    }
  }
};
</script>
<style lang="less">
.book-outlink {
  height: calc(100% - 60px);

  .prop-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .gold {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      background-color: red;
      border-radius: 50%;
      background: url(../../../assets/images/studyCenter/questions/gold-icon.png)
        center center no-repeat;
      background-size: cover;
    }
    .diamond {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      background-color: red;
      border-radius: 50%;
      background: url(../../../assets/images/myCenter/diamond.png) center
        center no-repeat;
      background-size: cover;
    }
  }
}
</style>